// @Version: 1.0.0
import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { IsRequiredService } from './is-required.service';

@Directive({
    selector: '[UploadIsRequired]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => UploadIsRequired),
            multi: true
        }
    ],
    standalone: false
})

export class UploadIsRequired implements Validator {
   constructor(public sIsRequired: IsRequiredService) {}
   
   validate (control: AbstractControl): ValidationErrors | null {
      if (!control.touched) {
         this.sIsRequired.required = true;
         return null;
      }
      return !control.value || (control.value && control.value.length == 0) ? { required: true } : null;
   }
}